import _ from "lodash";

export const computeSearchNavigation = ({
  results,
  searchParams,
  config,
  urlParams,
  initialCoordinates,
}) => {
  const isZipcodeSearch = !!urlParams.get("zipcode");
  const searchedFirstTime = searchParams._searchParams?.searchedFirstTime;
  const preventFlyParam = !!searchParams._searchParams?.preventFly;
  const firstResult = results?.[0];
  const hasResults = results?.length > 0;

  const fallbackLocationToStores =
    config?.fallbackLocationToStores || isZipcodeSearch;

  // Determine if we should fly to the first result or the searched coordinates
  const shouldUseFirstResultCoords =
    fallbackLocationToStores &&
    (isZipcodeSearch || !hasResults) &&
    searchedFirstTime === false;

  const hasValidFirstResultCoords =
    Number.isFinite(firstResult?.latitude) &&
    Number.isFinite(firstResult?.longitude);

  const flyToCoordinates =
    shouldUseFirstResultCoords && hasValidFirstResultCoords
      ? { lat: firstResult.latitude, lng: firstResult.longitude }
      : initialCoordinates;

  // Determine preventFly status
  const preventFly =
    ((!isZipcodeSearch && hasResults) ||
      (fallbackLocationToStores && searchedFirstTime === true)) &&
    preventFlyParam;

  return {
    flyToCoordinates,
    preventFly,
    fallbackRequired:
      (isZipcodeSearch || !hasResults) &&
      fallbackLocationToStores &&
      searchedFirstTime === false,
  };
};

export const markSearchedOnce = (oldParams) => ({
  ...oldParams?._searchParams,
  searchedFirstTime:
    oldParams?._searchParams?.searchedFirstTime === undefined ? false : true,
});

export const sortOptions = {
  images: (items) => {
    return _.sortBy(items, ["image_url", "secondary_images"]);
  },
  products: (items) => {
    return _.sortBy(items, ["products"]);
  },
};
